import type {ComponentProps, PropsWithChildren} from 'react'
import {clsx} from 'clsx'
import {Heading, Spinner} from '@primer/react'
import {Stack, InlineMessage, useSlots} from '@primer/react/experimental'
import {BetaLabel} from '@github-ui/lifecycle-labels/beta'
import styles from './BoxHeader.module.css'
import {useLoading} from '../contexts/LoadingContext'
import {useStatic} from '../contexts/StaticContext'

BoxHeader.Actions = Actions
BoxHeader.InlineMessage = InlineMessage

export {BoxHeader}

const boxHeaderSlotConfig = {
  actions: BoxHeader.Actions,
  inlineMessage: BoxHeader.InlineMessage,
}

function BoxHeader({
  children: slottedChildren,
  title,
  hidePreviewLabel,
  as,
}: PropsWithChildren<{title: string; hidePreviewLabel?: boolean; as?: ComponentProps<typeof Heading>['as']}>) {
  const {isPreview} = useStatic()
  const isLoading = useLoading()
  const [{actions, inlineMessage}] = useSlots(slottedChildren, boxHeaderSlotConfig)
  return (
    <Stack
      direction="horizontal"
      justify="space-between"
      align="center"
      className={clsx(styles.BoxHeader, 'Box-header py-2')}
    >
      <span className="Box-title text-bold d-flex flex-items-center gap-2">
        {as ? (
          <Heading as={as} className="h5">
            {title}
          </Heading>
        ) : (
          // eslint-disable-next-line react-google-translate/no-conditional-text-nodes-with-siblings
          title
        )}
        {!hidePreviewLabel && isPreview ? <BetaLabel /> : null}
        {!isLoading ? inlineMessage : null}
        {isLoading ? <Spinner srText={`Loading ${title}`} size="small" /> : null}
      </span>
      {actions}
    </Stack>
  )
}

function Actions({children}: PropsWithChildren) {
  return children
}
Actions.displayName = 'PanelList.BoxHeader.Actions'
